var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"#000"},attrs:{"id":"inspire"}},[_c('router-view'),_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }